import { DataSource } from '@n7-frontend/core';
import { IModalData } from '@app/components/modal/modal';

export class ModalReorderWidgetsDS extends DataSource {
  protected transform(): IModalData {
    return {
      isVisible: false,
      classes: 'iwt-layout-home__modal-reorder-widgets',
      header: {
        label: 'i18n.modal_reorder_widgets.title',
        closeButton: {
          payload: 'dismiss'
        }
      },
      footer: {
        actions: [{
          label: 'i18n.cancel',
          payload: 'dismiss'
        }, {
          buttonClasses: 'n7dash-btn-ok',
          label: 'i18n.modal_reorder_widgets.title',
          payload: 'reorder'
        }]
      }
    };
  }

  onOpen(){
    this.output.isVisible = true;
  }

  onDismiss(){
    this.output.isVisible = false;
  }
}
